import styled from '@emotion/styled';

export const TimerRoot = styled.div`
  padding: 20px 0;
  text-align: center;
  font-size: 14px;
  line-height: 21px;
  color: #babec4;
`;
